module.exports = __webpack_public_path__ + "static/media/AWS.aed5bcde.png";